@if (!isSuccess) {
<form class="w-12 block flex-column flex-justify-center left-s p-t-4-s p-b-6-s p-l-4-m p-l-4-s p-r-4-m p-r-4-s"
      [ngClass]="{'pos-absolute top-50': !isSimple && !client.isS}"
      name="bis"
      method="POST"
      #form="ngForm">
    <p class="m-b-2 h2">{{'Email me when back in stock' | translate}}</p>
    @if (model.data?.size) {
    <p class="p1">
        <span [innerHTML]="'Enter your email address and we will notify you when' | translate"></span>
        @if (!isSimple) {
        @if (model?.data?.size) {
        <span class="fw-bold">&nbsp;size {{model.data.size | optionLabel : 'size'}}&nbsp;</span>
        }
        <span [innerHTML]="'becomes available again' | translate"></span>.
        } @else {
        <span [innerHTML]="'when back in stock' | translate"></span>.
        }
    </p>
    } @else {
    <p class="p1"
       [innerHTML]="'Enter your email address and we will notify you when this item becomes available again.' | translate">
    </p>
    }
    <!-- email entry -->
    <input-wrap class="m-t--2">
        <input class="input"
               type="email"
               name="email"
               maxlength="100"
               required
               [muiInput]="'Email address'"
               [(ngModel)]="data.email"
               (ngModelChange)="onEmailChange()">
    </input-wrap>
    <!-- submission -->
    <div class="m-t-2 p-b pos-relative">
        <button class="button w-12"
                [action]="status"
                (click)="submit()">
            <span>{{'Send notification' | translate}}</span>
        </button>

        <!-- result -->
        <result class="pos-absolute bottom-0 block"
                [status]="status" />
    </div>
    @if (showSubscriptionOptIn) {
    <div class="w-12 bg-col-5 p-l m-t-0-s m-t-0-m"
         [class.m-t]="!isSimple">
        <checkbox class="label block"
                  name="newsletter"
                  sl-input="newsletter"
                  [(ngModel)]="data.newsletter">
            <p class="s1 p-t-3 fw-bold p-l-1 block">{{'Subscribe to our email newsletter' | translate}}</p>
            <p class="p2 fw-bold p-l-1 block">{{'Newness, sales and offers to your inbox.' | translate}}</p>
        </checkbox>
        <p class="c1 m-t-1 m-l-8-s m-l-7-m p-l-1-s p-b-3 subscribe-copy">
            {{'Tick to sign up' | translate}}.&nbsp;
            <a class="link underline"
               href="/privacy-policy"
               target="_blank"
               rel="noopener">{{'Privacy Policy' | translate}}</a>.
        </p>
    </div>
    }
</form>
} @else {
<div class="flex-x flex-l flex-middle-x flex-middle-l flex-top-m flex-top-s m-t-20-s m-t-20-m notify-confirmation">
    <div class="p-a-4-s left-s">
        <p class="h2">{{'You’re on the list' | translate}}</p>
        <p class="p1 m-t m-t-2-m m-t-2-s">{{'Thank you, we’ll contact you when this product becomes available.' |
            translate}}</p>
        @if (client.isS || client.isM) {
        <button class="w-12 m-t h3 button"
                (click)="closeAllModals()">
            <span>{{'Continue shopping' | translate}}</span>
        </button>
        }@else {
        <button class="w-12 m-t h3 button"
                (click)="closeModal()">
            <span>{{'Continue shopping' | translate}}</span>
        </button>
        }
    </div>
</div>
}